import { Component, OnInit, Input, forwardRef, ViewEncapsulation, ViewChild, ChangeDetectorRef } from '@angular/core';
import { ControlValueAccessor, NG_VALUE_ACCESSOR } from '@angular/forms';
import { ConversationContact } from 'app/clmtlk/shared/model/conversationContacts';
import { ClmtlkService } from 'app/clmtlk/shared/service/clmtlk.service';
import { NgbModal, ModalDismissReasons } from '@ng-bootstrap/ng-bootstrap';
import { ClmtlkSessionService } from 'app/clmtlk/shared/service/clmtlk-session.service';
import { ToastrService } from 'ngx-toastr';
import { ConfirmDialogModule, ConfirmationService, SharedModule } from 'primeng/primeng';


@Component({
  selector: 'clmtlk-auto-complete',
  templateUrl: './auto-complete.component.html',
  styleUrls: ['./auto-complete.component.scss'],
  providers: [
    {
      provide: NG_VALUE_ACCESSOR,
      useExisting: forwardRef(() => AutoCompleteComponent),
      multi: true
    },
    ConfirmationService
  ],
  encapsulation: ViewEncapsulation.None
})
export class AutoCompleteComponent implements OnInit, ControlValueAccessor {

  @Input() autoCompleteId: String;
  newFreeFormContact: ConversationContact;
  //@ViewChild('TO') autoCompleteTemp;

  conversationContacts: ConversationContact[] = [];
  refDataConversationContacts: ConversationContact[];
  suggestionConvContacts: ConversationContact[];
  loggedInUser: ConversationContact;

  currentUserId:String;

  onModelChange: Function = (_: any) => { };

  onModelTouch: Function = (_: any) => { };

  constructor(private modalService: NgbModal,
              private clmtlkService: ClmtlkService,
              private clmtlkSessionService: ClmtlkSessionService,
              private cdr: ChangeDetectorRef,
              private confirmationService: ConfirmationService,
              private toastrService: ToastrService
            ) { }

  ngOnInit() {
    console.info("this.clmtlkSessionService", this.clmtlkSessionService);
    this.clmtlkSessionService.loggedInUserObserver.subscribe(loggedInContact => {
      //this.loggedInUser = loggedInContact;
      //console.info("loggedInContact",loggedInContact)
  });

    if (this.clmtlkSessionService.streamContacts &&
        this.clmtlkSessionService.streamContacts.length > 0) {
          this.refDataConversationContacts = this.clmtlkSessionService.streamContacts;
      }else {
        // this.clmtlkService.getContactList()
        // .subscribe(result => {
        //   this.refDataConversationContacts = result;
        // },
        // error => {
          this.toastrService.warning(` Failed to load Autocomplete data `, 'Unsuccess' );
      //   }
      // );
      }
    this.loggedInUser = this.clmtlkSessionService.loggedInContact;
    //this.currentUserId = this.loggedInUser.contacts.contact[0].
    //console.info("this.loggedInUser",this.loggedInUser);

  };

  writeValue(obj: any): void {
    if (obj && obj.constructor === Array) {
      this.conversationContacts = <ConversationContact[]>obj;
    }
  }

  registerOnChange(fn: any): void {
    this.onModelChange = fn;
  };

  registerOnTouched(fn: any): void {
    this.onModelTouch = fn;
  };

  setDisabledState(isDisabled: boolean): void {
  };
  updateOptInStatus(convContact: ConversationContact){
    //console.info("updateOptInStatus", convContact);
  }
  onClick(disabled: boolean) {
    //console.log('Event triggered');
		if(disabled) {
			event.stopPropagation();
		}
	}
  search(queryInput: any) {
    this.suggestionConvContacts = [];
    const convContacts: ConversationContact[] = [];

    if (queryInput.query === undefined || queryInput.query === '') {
      return;
    }

    //console.info("this.refDataConversationContacts", this.refDataConversationContacts);
    if (queryInput.query.startsWith('#')) {
      for (const item of this.refDataConversationContacts) {
        if(item.contacts.contact[0].CTC_TYP_CD==='sms'){
          //console.info("item",item);
          item.displayOptInOut=true;
          item.reqOptIn = (item.contacts.contact[0].contactOptStatuses.contactOptStatus.CTC_OPT_STS_CD==='U')
          //console.info("item",item);
        }
        if ((item.CTC_SRC_CD !== 'st' && this.loggedInUser.CTC_SRC_CD === 'st') || this.loggedInUser.CTC_SRC_CD !== 'st') {
          convContacts.push(item);
        }
      }
    } else {
      for (const item of this.refDataConversationContacts) {

        //SP added filtering here as well as stream users can directly start typing
        //instead of using #
        if(item.contacts.contact[0].CTC_TYP_CD==='sms'){
          //console.info("item",item);
          item.displayOptInOut=true;
          item.reqOptIn = (item.contacts.contact[0].contactOptStatuses.contactOptStatus.CTC_OPT_STS_CD==='U')
          //console.info("item",item);
        }

        if (item.contacts.contact[0].contactRole &&
          item.contacts.contact[0].contactRole.toUpperCase().
            startsWith(queryInput.query.toUpperCase())) {
          convContacts.push(item);
        }
      }
    }
    this.suggestionConvContacts = convContacts;
    console.info("this.suggestionConvContacts",this.suggestionConvContacts);
  }

  onBlur(event) {
    event.currentTarget.value = '';
    //console.info("onSelect- before: ", this.conversationContacts);
    this.onModelChange(this.conversationContacts);
    this.onModelTouch();
    //console.info("onSelect", this.conversationContacts);
  }

  onSelect(event) {
    this.onModelChange(this.conversationContacts);

  }

  onUnselect(event) {
    this.onModelChange(this.conversationContacts);
    console.info("onUnselect", this.conversationContacts);
  }

  // onFocus(event){
  //   this.autoCompleteTemp.completeMethod(event);
  // }

  handleDropdownClick(event) {
    this.suggestionConvContacts = [];
    setTimeout(() => {
      this.suggestionConvContacts = this.refDataConversationContacts.slice();
    }, 100);

  }

  openRecipientModal(content) {
    const modalOptions: any = { backdrop: 'static', keyboard: false };
    console.info("openRecipientModal");
    this.newFreeFormContact = <ConversationContact>{
        CTC_SRC_CD: 'ex',
        CTC_STS_CD: 'V',
        CONV_CTX_REF_ID: this.clmtlkSessionService.loggedInContact.CONV_CTX_REF_ID,
        contacts: {
          contact: [{
            CTC_TYP_CD: 'email'
          }]
        }
    };

    this.modalService.open(content, modalOptions).result.then((result) => {
      this.conversationContacts.push(this.newFreeFormContact);
      this.onModelChange(this.conversationContacts);
    }, (reason) => {
      console.log(reason);
    });
  }

  resetAddress() {
    this.newFreeFormContact.contacts.contact[0].CTC_VAL_TXT = null;
  }

  removeFromTheList(contact){
    const index: number = this.conversationContacts.indexOf(contact);
    console.info("index",index)
    if (index !== -1) {
        this.conversationContacts.splice(index, 1);
    }
  }
  onSelectContact(contact){
    //console.log("OnselectContact fired", contact);
    //SP Prevent users from selecting an opted out entry from a keyboard operation
    if(contact.contacts.contact[0].contactOptStatuses
      && contact.contacts.contact[0].contactOptStatuses.contactOptStatus.CTC_OPT_STS_CD==='U'){
      this.removeFromTheList(contact);
    }
    /*
    console.info("onSelectContact",contact,contact.reqOptIn);
    //console.info("onSelect", this.conversationContacts);
    if(contact.reqOptIn){
      this.confirmationService.confirm({
        message: 'This Contact Need SMS Notification Subscription, Are you sure that you want to Subscribe and send SMS Notification to this Contact?',
        accept: () => {
          console.info("Calling Service to Opt In");
          //var newContact = new WhitelistContact(this.claimNumber,"","","sms","","","U","",false,this.userId,now.toString(),this.userId,now.toString(),"");
        },
        reject:() =>{
          this.removeFromTheList(contact);
          console.info("Remove from the List");
        }
    });
    }
    this.onModelChange(this.conversationContacts);
    this.onModelTouch();
    */
  }

}



// WEBPACK FOOTER //
// /var/jenkins_home/workspace/CLAIMS_PIPELINE/CLMTLK_UI_APP_PIPELINE/src/app/clmtlk/new-message/message-form/auto-complete/auto-complete.component.ts